/*
* Swipe 1.0
*
* Brad Birdsall, Prime
* Copyright 2011, Licensed GPL & MIT
* swipejs.com
*
* This version of swipe has been modified for use at EF.
* New features include "peek" and a "kill" method.
* This version differs from Swipe 2.0.
* v1.0 docs: https://github.com/bradbirdsall/Swipe/blob/67928de65e805062f341ca6cf6d14ec16b19eaf3/README.md
*
* The setSameHeightSlides has been moved to a standalone plugin, $.equalHeight.
*/
define('core/ef_plugins/swipe',["jquery"], function($) {
    console.log("swipe");
    window.Swipe = function(element, options) {

        // return immediately if element doesn't exist
        if (!element) return null;

        var _this = this;

        // check browser capabilities - from Swipe 2.0
        this.browser = {
            addEventListener: !!window.addEventListener,
            touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch,
            transitions: (function(temp) {
                var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];
                for (var i in props) if (temp.style[props[i]] !== undefined) return true;
                return false;
            })(document.createElement('swipe'))
        };

        // retreive options
        this.options = options || {};
        this.index = this.options.startSlide || 0;
        this.speed = this.options.speed || 300;
        this.callback = this.options.callback || function() {};
        this.delay = this.options.auto || 0;
        this.peek = this.options.peek || element.getAttribute('data-swipe-peek') === "true" || false;
        this.peekSlideWidth = 0.85; // Percentage of parent as decimal
        this.peekSlideSpacing = 15; // static pixel width between each peeking slide
        this.maxSlideWidth = 350; // static maximum pixel width for each slide
        this.positionIndicator = this.options.positionIndicator || element.getAttribute('data-swipe-position-indicator') === "true" || false;
        this.positionIndicatorChar = '\u2022';
        this.positionCounter = this.options.counter || element.getAttribute('data-swipe-position-counter') === "true" || false;
        this.positionCounterSpacer = this.options.positionCounterSpacer || element.getAttribute('data-swipe-position-counter-spacer') || " of ";
        this.arrows = this.options.arrows || element.getAttribute('data-swipe-arrows') === "true" || false;
        this.arrowHolder = this.options.arrowHolder || null; // Element to which we add the arrow nav. If null, add arrows to this.nav.
        this.arrowsToEdge = this.options.arrowsToEdge; // Should arrows "stick" to edge of window?
        this.arrowsToEdgeCutoff = this.options.arrowsToEdgeCutoff || 580; // At or below this width, arrows will not stick to edge of window, even if arrowsToEdge is true.
        // reference dom elements
        this.container = element;
        this.element = this.container.children[0]; // the slide pane

        // static css
        this.element.style.listStyle = 'none';
        this.element.style.margin = 0;

        // get and measure amt of slides
        this.slides = this.element.children;
        this.length = this.slides.length;

        // return immediately if their are less than two slides
        // moved this up here from setup to avoid listeners and solve error when only 1 slide exists
        if (this.length < 2) return null;

        if (this.positionIndicator || this.positionCounter || this.arrows) this.setupNav();

        // trigger slider initialization
        this.setup();

        // begin auto slideshow
        this.begin();

        // add event listeners
        if (this.browser.addEventListener) {
            this.element.addEventListener('touchstart', this, false);
            this.element.addEventListener('touchmove', this, false);
            this.element.addEventListener('touchend', this, false);
            this.element.addEventListener('webkitTransitionEnd', this, false);
            this.element.addEventListener('msTransitionEnd', this, false);
            this.element.addEventListener('oTransitionEnd', this, false);
            this.element.addEventListener('transitionend', this, false);
            window.addEventListener('resize', this, false);
        }


    };

    Swipe.prototype = {
        setup: function() {

            var _this = this;

// determine width of each slide
            this.containerWidth = this.container.getBoundingClientRect().width || this.container.offsetWidth;

            // return immediately if measurement fails
            if (!this.containerWidth) return null;

            // hide slider element but keep positioning during setup
            this.container.style.visibility = 'hidden';


            // calculate the width of each slide
            this.slideWidth = this.peek ? this.containerWidth * this.peekSlideWidth : this.containerWidth;
            this.slideWidth = this.slideWidth > this.maxSlideWidth ? this.maxSlideWidth : this.slideWidth;
            this.slideSpacing = this.peek ? this.peekSlideSpacing : 0; // Makes it easier later on when sliding to call this variable regardless
            this.elementWidth = this.slides.length * (this.slideWidth + this.slideSpacing);

            // calculate the width of the wrap element
            this.element.style.width = this.elementWidth + 'px';
            this.element.style.paddingLeft = this.slideSpacing + 'px';
            this.element.style.paddingRight = this.slideSpacing + 'px';
            this.element.style.paddingTop = 0;
            this.element.style.paddingBottom = 0;

            // set the width used for calculating slide distances
            this.width = this.slideWidth + this.slideSpacing;

            var el, index = this.length;

            // set style of each slide
            while (index--) {
                el = this.slides[index];
                el.style.width = this.slideWidth + 'px';
                if (index != this.length - 1) el.style.marginRight = this.slideSpacing + 'px';
                el.style.display = 'block'; //'table-cell';
                el.style.styleFloat = 'left';
                el.style.cssFloat = 'left';
            }

            // set start position and force translate to remove initial flickering
            this.slide(this.index, 0);

            // show slider element
            this.container.style.visibility = 'visible';

            if (this.arrows && this.arrowsToEdge && ($(window).width() > this.arrowsToEdgeCutoff)) {
                this.setupArrowsToEdge();
            } else {
                this.teardownArrowsToEdge();
            }

            

        },

        hasOrientationChanged: function (window) {
            // check for browser orientation change
            var orientation = window.orientation;

            if (window.matchMedia("(orientation: portrait)").matches && orientation !== 'portrait') {
         
                window.orientation = 'portrait';
                console.log(window.orientation);
                this.setup();
            }

            if (window.matchMedia("(orientation: landscape)").matches && orientation !== 'landscape') {
               
                window.orientation = 'landscape';
                console.log(window.orientation);
                      this.setup();
            }



        },

        setupNav: function() {
            // get and measure amt of slides
            this.slides = this.element.children;
            this.length = this.slides.length;

            // return immediately if their are less than two slides
            if (this.length < 2) return null;

            // create nav wrapping element
            this.nav = document.createElement('div');
            this.nav.setAttribute('class', 'swipe-nav');


            // Figure out where to place the arrows
            if (!this.arrowHolder) { // If this.arrowHolderId is null or undefined, use this.nav instead.
                this.arrowHolder = this.nav;
            }

            if (this.arrows) {
                this.setupArrows();
                this.arrowHolder.appendChild(this.prevArrow);
                this.arrowHolder.appendChild(this.nextArrow);
            }

            if (this.positionIndicator) {
                this.setupPositioner();
                this.nav.appendChild(this.positioner);
            }

            if (this.positionCounter) {
                this.setupCounter();
                this.nav.appendChild(this.counter);
            }

            this.container.appendChild(this.nav);
        },

        updateNav: function(index) {
            if (this.positionIndicator) this.setPositionerPosition(index);
            if (this.positionCounter) this.setCounterPosition(index);
            if (this.arrows) this.updateArrows(index);
        },

        setupArrows: function() {
            var _this = this;
            this.nextArrow = document.createElement('a');
            this.nextArrow.setAttribute('class', 'swipe-next-arrow');
            this.nextArrow.appendChild(document.createTextNode('>'));
            this.nextArrow.onclick = function() { _this.next(); };

            this.prevArrow = document.createElement('a');
            this.prevArrow.setAttribute('class', 'swipe-prev-arrow');
            this.prevArrow.appendChild(document.createTextNode('<'));
            this.prevArrow.onclick = function() { _this.prev(); };

            this.updateArrows(this.index);
        },

        updateArrows: function(index) {
            if (index == 0) {
                this.prevArrow.style.visibility = 'hidden';
                this.nextArrow.style.visibility = 'visible';
            } else if (index == this.length - 1) {
                this.prevArrow.style.visibility = 'visible';
                this.nextArrow.style.visibility = 'hidden';
            } else {
                this.prevArrow.style.visibility = 'visible';
                this.nextArrow.style.visibility = 'visible';
            }
        },

        setupCounter: function() {
            this.counter = document.createElement('div');
            this.counter.setAttribute('class', 'swipe-counter');

            // span to hold current slide number
            this.counter.current = document.createElement('span');
            this.counter.current.setAttribute('class', 'swipe-counter-current');
            this.counter.current.appendChild(document.createTextNode(this.index + 1));

            // span to hold spacer text
            this.counter.spacer = document.createElement('span');
            this.counter.spacer.setAttribute('class', 'swipe-counter-spacer');
            this.counter.spacer.appendChild(document.createTextNode(this.positionCounterSpacer));

            // span to hold total slide number
            this.counter.total = document.createElement('span');
            this.counter.total.setAttribute('class', 'swipe-counter-total');
            this.counter.total.appendChild(document.createTextNode(this.length));

            // add em all in
            this.counter.appendChild(this.counter.current);
            this.counter.appendChild(this.counter.spacer);
            this.counter.appendChild(this.counter.total);
        },

        setCounterPosition: function(index) {
            this.counter.current.removeChild(this.counter.current.firstChild);
            this.counter.current.appendChild(document.createTextNode(index + 1));
        },

        setupPositioner: function() {
            // create position element
            this.positioner = document.createElement('div');
            this.positioner.setAttribute('class', 'swipe-position');

            var len = this.length,
                plugin = this;
            while (len--) {
                var position = document.createElement('span'),
                    positionText = document.createTextNode(this.positionIndicatorChar);
                position.appendChild(positionText);
                position.addEventListener('click', function(len) {
                    // In order to use array methods on a node list, some gymnastics
                    // are necessary: http://stackoverflow.com/a/9132575/925475
                    // This won't work in IE <= 9. A jQuery equivalent would.
                    var siblings = this.parentNode.childNodes,
                        index = Array.prototype.indexOf.call(siblings, this);
                    plugin.gotoSlide(index);
                }, false);
                this.positioner.appendChild(position);
            }
            // set position
            this.setPositionerPosition(this.index);
        },

        setPositionerPosition: function(index) {
            var positions = this.positioner.children,
                i = positions.length;
            while (i--) {
                positions[i].className = ' ';
            }
            positions[index].className = 'swipe-position-current';
        },

        setupArrowsToEdge: function() {
            /* Position the arrows at the edge of the window, even if they are within a container with position: relative.
            *  jQuery dependency ahoy!
            *  window.innerWidth isn't supported in IE8, and document.body.clientWidth is unreliable.
            *  So, we're using $.width instead. More info: http://stackoverflow.com/questions/833699/ */
            var posRight = Math.ceil($(window).width() - $(this.arrowHolder).outerWidth() - $(this.arrowHolder).offset().left) * -1;
            var posLeft = Math.ceil($(this.arrowHolder).offset().left) * -1;
            $(this.nextArrow).css('right', posRight + 'px');
            $(this.prevArrow).css('left', posLeft + 'px');
            $(this.arrowHolder).addClass('swipe-arrows-to-edge');
        },

        teardownArrowsToEdge: function() {
            if (this.arrows) {
                $(this.nextArrow).css('right', '');
                $(this.prevArrow).css('left', '');
                $(this.arrowHolder).removeClass('swipe-arrows-to-edge');
            }
        },

        slide: function(index, duration) {

            var style = this.element.style;

            // fallback to default speed
            if (duration == undefined) {
                duration = this.speed;
            }

            // set duration speed (0 represents 1-to-1 scrolling)
            style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration = duration + 'ms';

            // translate to given index position
            // max position is element width - width
            var position = index * this.width,
                maxposition = this.elementWidth - this.containerWidth + this.slideSpacing;
            if (position > maxposition) position = maxposition;
            style.MozTransform = style.webkitTransform = 'translate3d(' + -(position) + 'px,0,0)';
            style.msTransform = style.OTransform = 'translateX(' + -(position) + 'px)';

            if (!this.browser.transitions) {
                this.element.style.marginLeft = -(position) + 'px';
            }

            // set new index to allow for expression arguments
            this.index = index;

            // update navigation
            if (this.positionIndicator || this.positionCounter || this.arrows) this.updateNav(index);


        },

        getPos: function() {

            // return current index position
            return this.index;

        },

        prev: function(delay) {

            // cancel next scheduled automatic transition, if any
            this.delay = delay || 0;
            clearTimeout(this.interval);

            // if not at first slide
            if (this.index) this.slide(this.index - 1, this.speed);

        },

        next: function(delay) {

            // cancel next scheduled automatic transition, if any
            this.delay = delay || 0;
            clearTimeout(this.interval);

            if (this.index < this.length - 1) this.slide(this.index + 1, this.speed); // if not last slide
            else this.slide(0, this.speed); //if last slide return to start

        },

        gotoSlide: function(targetIndex, delay) {
            // cancel next scheduled automatic transition, if any
            this.delay = delay || 0;
            clearTimeout(this.interval);
            if (targetIndex >= 0 && targetIndex < this.length && targetIndex != this.index) {
                // If targetIndex is a valid slide index and isn't the current slide, go to the slide
                this.slide(targetIndex, this.speed);
            }

        },

        begin: function() {

            var _this = this;

            this.interval = (this.delay)
                ? setTimeout(function() {
                    _this.next(_this.delay);
                }, this.delay)
                : 0;

        },

        stop: function() {
            this.delay = 0;
            clearTimeout(this.interval);
        },

        resume: function() {
            this.delay = this.options.auto || 0;
            this.begin();
        },

        handleEvent: function (e) {
            switch (e.type) {
            case 'touchstart':
                this.onTouchStart(e);
                break;
            case 'touchmove':
                this.onTouchMove(e);
                break;
            case 'touchend':
                this.onTouchEnd(e);
                break;
            case 'webkitTransitionEnd':
            case 'msTransitionEnd':
            case 'oTransitionEnd':
            case 'transitionend':
                this.transitionEnd(e);
                break;
                case 'resize':
                    this.hasOrientationChanged(window); // we might resize but not change orientation
                break;
          
                
            }
        },

        transitionEnd: function(e) {

            if (this.delay) this.begin();

            this.callback(e, this.index, this.slides[this.index]);

        },

        onTouchStart: function (e) {

            this.start = {

                // get touch coordinates for delta calculations in onTouchMove
                pageX: e.touches[0].pageX,
                pageY: e.touches[0].pageY,

                // set initial timestamp of touch sequence
                time: Number(new Date())

            };

            // used for testing first onTouchMove event
            this.isScrolling = undefined;

            // reset deltaX
            this.deltaX = 0;

            // set transition time to 0 for 1-to-1 touch movement
            this.element.style.MozTransitionDuration = this.element.style.webkitTransitionDuration = 0;

            e.stopPropagation();
        },

        onTouchMove: function (e) {

            // ensure swiping with one touch and not pinching
            if (e.touches.length > 1 || e.scale && e.scale !== 1) return;

            this.deltaX = e.touches[0].pageX - this.start.pageX;

            // determine if scrolling test has run - one time test
            if (typeof this.isScrolling == 'undefined') {
                this.isScrolling = !!(this.isScrolling || Math.abs(this.deltaX) < Math.abs(e.touches[0].pageY - this.start.pageY));
            }

            // if user is not trying to scroll vertically
            if (!this.isScrolling) {

                // prevent native scrolling 
                e.preventDefault();

                // cancel slideshow
                clearTimeout(this.interval);

                // increase resistance if first or last slide
                this.deltaX =
                    this.deltaX /
                    ((!this.index && this.deltaX > 0 // if first slide and sliding left
                                || this.index == this.length - 1 // or if last slide and sliding right
                                && this.deltaX < 0 // and if sliding at all
                        ) ?
                        (Math.abs(this.deltaX) / this.width + 1) // determine resistance level
                        : 1); // no resistance if false

                // translate immediately 1-to-1
                this.element.style.MozTransform = this.element.style.webkitTransform = 'translate3d(' + (this.deltaX - this.index * this.width) + 'px,0,0)';

                e.stopPropagation();
            }

        },

        onTouchEnd: function(e) {

            // determine if slide attempt triggers next/prev slide
            var isValidSlide =
                    Number(new Date()) - this.start.time < 250 // if slide duration is less than 250ms
                        && Math.abs(this.deltaX) > 20 // and if slide amt is greater than 20px
                        || Math.abs(this.deltaX) > this.width / 2, // or if slide amt is greater than half the width

                // determine if slide attempt is past start and end
                isPastBounds =
                    !this.index && this.deltaX > 0 // if first slide and slide amt is greater than 0
                        || this.index == this.length - 1 && this.deltaX < 0; // or if last slide and slide amt is less than 0

            // if not scrolling vertically
            if (!this.isScrolling) {

                // call slide function with slide end value based on isValidSlide and isPastBounds tests
                this.slide(this.index + (isValidSlide && !isPastBounds ? (this.deltaX < 0 ? 1 : -1) : 0), this.speed);

            }

            e.stopPropagation();
        },
        kill: function() { // Adapted from Swipe 2.0

            // cancel slideshow
            this.stop();

            // reset element
            this.element.style.width = '';
            this.element.style.padding = '';
            this.element.style.left = '';
            this.element.style.listStyle = '';
            this.element.style.margin = '';

            if (this.browser.transitions) {
                this.element.style.MozTransform = this.element.style.webkitTransform = 'translate3d(0,0,0)';
                this.element.style.msTransform = this.element.style.OTransform = 'translateX(0)';
            };

            // reset slides
            var pos = this.slides.length;
            while (pos--) {

                var slide = this.slides[pos];
                slide.style.width = '';
                slide.style.height = '';
                slide.style.marginRight = '';
                slide.style.left = '';
                slide.style.styleFloat = '';
                slide.style.cssFloat = '';
                slide.style.display = '';

                if (this.browser.transitions) {
                    slide.style.MozTransform = slide.style.webkitTransform = 'translate3d(0,0,0)';
                    slide.style.msTransform = slide.style.OTransform = 'translateX(0)';
                };

            }

            // removed event listeners
            if (this.browser.addEventListener) {

                // remove current event listeners
                this.element.removeEventListener('touchstart', this, false);
                this.element.removeEventListener('touchmove', this, false);
                this.element.removeEventListener('touchend', this, false);
                this.element.removeEventListener('webkitTransitionEnd', this, false);
                this.element.removeEventListener('msTransitionEnd', this, false);
                this.element.removeEventListener('oTransitionEnd', this, false);
                this.element.removeEventListener('otransitionend', this, false);
                this.element.removeEventListener('transitionend', this, false);
                window.removeEventListener('resize', this, false);

            } else {
                // TODO: will this unbind the event handlers in global.js?
                window.onresize = null;
            }
            if (this.nav) {
                this.nav.parentNode.removeChild(this.nav);
            }
            $(this.container).data('Swipe', null);
        }
    };

    // bridge to jquery plugin
    $.fn.Swipe = function(params) {
        return this.each(function() {
            var _this = $(this);
            _this.data('Swipe', new Swipe(_this[0], params));
        });
    }
});
